import httpClient from '@/libs/http-client'
import { readFunnelReport, readFunnelStream } from '@/libs/heatmap-v2/followup'

export function getFunnel (fid) {
  const url = `/funnel/get_funnel/${fid}`

  return httpClient.get(url).then(response => {
    const data = response.data.result
    return data
  })
}

export function getFunnelList (params) {
  const url = '/funnel/get_list'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function getFunnelStream (params) {
  const url = '/funnel/get_funnel_stream'

  return readFunnelStream(params, () => httpClient.post(url, params).then(response => {
    return response.data.result
  }))
}

export function getFunnelFlow (params) {
  const url = '/funnel/flow'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}

export function getReport (params) {
  const url = '/funnel/get_report'

  return readFunnelReport(params, () => httpClient.post(url, params).then(response => {
    const data = response.data.result
    return data
  }))
}

export function insertFunnel (params) {
  const url = '/funnel/insert_funnel'

  return httpClient.post(url, params).then(response => {
    const data = response.data.result
    return data
  })
}

export function deleteFunnel (fid) {
  const url = '/funnel/delete'

  return httpClient.post(url, { fid }).then(response => {
    const data = response.data.result
    return data
  })
}

export function checkAid (aid) {
  const url = `/funnel/check_aid/${aid}`

  return httpClient.get(url).then(response => {
    const data = response.data.result
    return data
  })
}

export function getFunnelSession (params) {
  const url = '/funnel/session_replay'

  return httpClient.post(url, params).then(response => {
    return response.data.result
  })
}
